import {kSystemIcons} from "../../../constants/icons";
import GlossarySearchLoader from "../../loaders/glossaryScreen/GlossarySearchLoader";
import GlossaryResearchClearButton from "../../buttons/glossaryScreen/GlossaryResearchClearButton";

export default function GlossarySearchBar({search, isSearching, handleSearchChange}) {
    // Used in

    // BUILD
    return (
        <div className="bg-backgroundLight5 w-[320px] max-w-[320px] h-[44px] flex items-center space-x-[8px] border-[2px] border-backgroundLight7 rounded-[8px] pl-[4px] pr-[6px]">
            <div className="select-none bg-backgroundLight6 w-[32px] min-w-[32px] h-[32px] min-h-[32px] flex justify-center items-center rounded-[4px]">
                <i className="material-icons text-[20px] text-greyLight9">
                    {kSystemIcons.search}
                </i>
            </div>
            <input className="bg-transparent flex-grow px-[4px] py-[2px] focus:outline-none placeholder:text-greyLight5"
                   type="text"
                   placeholder="Angle, multiplier, ..."
                   value={search}
                   onChange={(e) => handleSearchChange(e.target.value)} />
            {isSearching
                ? <GlossarySearchLoader />
                : <GlossaryResearchClearButton search={search}
                                               onClear={() => handleSearchChange('')} /> }
        </div>
    );
}